import usaFlag from "../../img/flagImages/usa.svg";
import spainFlag from "../../img/flagImages/spain.svg";

export const languageKey = {
  en: "en",
  sp: "es",
};
export const languageArray = [
  {
    key: languageKey.en,
    label: "English",
    flagImage: usaFlag,
    locale: "en",
  },
  {
    key: languageKey.sp,
    label: "Español",
    flagImage: spainFlag,
    locale: "es",
  },
];
